// removed by extract-text-webpack-plugin
module.exports = {"theme":"#0B4F87","themeBg":"#f4ebe0","textColor":"#333","subTextColor":"#999","activeColor":"#0B4F87"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 6